/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type images_GenerateUploadURLRequest = {
    contentType: string;
    description?: string;
    /**
     * EntityID is required when Purpose is "avatar", optional for other purposes.
     * Cross-field validation (entityType+entityId pairing) is handled in the handler.
     */
    entityId?: string;
    /**
     * EntityType is required when Purpose is "avatar", optional for other purposes.
     * Cross-field validation (entityType+entityId pairing) is handled in the handler.
     */
    entityType?: string;
    filename: string;
    purpose: images_GenerateUploadURLRequest.purpose;
    sizeBytes: number;
};
export namespace images_GenerateUploadURLRequest {
    export enum purpose {
        AVATAR = 'avatar',
        DOCUMENT = 'document',
        ATTACHMENT = 'attachment',
        EXPORT = 'export',
    }
}

